<template>
  <div :class="rootClass">
    <div :class="rootClass + '__menu-right-dropdown'">
      <b-button
          :class="rootClass + '__menu-btn'"
          style="padding: 0.4rem 0.4rem"
      >
        <feather-icon class="mr-50" icon="MenuIcon" size="20"/>
      </b-button>
      <div :class="rootClass + '__dropdown-content'">
        <a
            :class="rootClass + '__dropdown-content-item'"
            href="#"
            @click="openTab('SubscriberInformation', 'Thông tin thuê bao')"
        >
          <div :class="rootClass + '__dropdown-content-item-left'"></div>
          <div :class="rootClass + '__dropdown-content-item-right'">
            Thông tin thuê bao<span
              :class="rootClass + '__dropdown-content-icon'"
          ><feather-icon class="mr-50" icon="UserIcon" size="16"
          /></span>
          </div>
        </a>
        <a :class="rootClass + '__dropdown-content-item'" href="#">
          <div :class="rootClass + '__dropdown-content-item-left'">&#8249;</div>
          <div :class="rootClass + '__dropdown-content-item-right'">
            Tra cứu<span :class="rootClass + '__dropdown-content-icon'"
          ><feather-icon class="mr-50" icon="GridIcon" size="16"
          /></span>
          </div>
          <div :class="rootClass + '__dropdown-content-sub'">
            <a
                :class="rootClass + '__dropdown-content-item'"
                href="#"
                @click="openTab('SearchCRS', 'Tra cứu CRS')"
            >
              <div :class="rootClass + '__dropdown-content-item-left'"></div>
              <div :class="rootClass + '__dropdown-content-item-right'">
                Tra cứu CRS<span :class="rootClass + '__dropdown-content-icon'"
              ><feather-icon class="mr-50" icon="GridIcon" size="16"/>
                </span>
              </div>
            </a>
            <a
                :class="rootClass + '__dropdown-content-item'"
                href="#"
                @click="openTab('SearchPackage', 'Tra cứu gói cước đăng kí được')"
            >
              <div :class="rootClass + '__dropdown-content-item-left'"></div>
              <div :class="rootClass + '__dropdown-content-item-right'">
                Tra cứu gói cước đăng ký được<span
                  :class="rootClass + '__dropdown-content-icon'"
              ><feather-icon class="mr-50" icon="GridIcon" size="16"
              /></span>
              </div>
            </a>
            <a
                :class="rootClass + '__dropdown-content-item'"
                href="#"
                @click="openTab('SearchListHistory', 'Tra cứu lịch sử thuê bao')"
            >
              <div :class="rootClass + '__dropdown-content-item-left'"></div>
              <div :class="rootClass + '__dropdown-content-item-right'">
                Tra cứu lịch sử thuê bao<span
                  :class="rootClass + '__dropdown-content-icon'"
              ><feather-icon class="mr-50" icon="GridIcon" size="16"
              /></span>
              </div>
            </a>
            <a
                :class="rootClass + '__dropdown-content-item'"
                href="#"
                @click="openTab('MsinToMsisdn', 'Tra cứu Serial Sim ra số')"
            >
              <div :class="rootClass + '__dropdown-content-item-left'"></div>
              <div :class="rootClass + '__dropdown-content-item-right'">
                Tra cứu Serial Sim ra số<span
                  :class="rootClass + '__dropdown-content-icon'"
              ><feather-icon class="mr-50" icon="GridIcon" size="16"
              /></span>
              </div>
            </a>
            <a
                :class="rootClass + '__dropdown-content-item'"
                href="#"
                @click="openTab('NoNumberToMsindn', 'Tra cứu số CCCD ra SĐT')"
            >
              <div :class="rootClass + '__dropdown-content-item-left'"></div>
              <div :class="rootClass + '__dropdown-content-item-right'">
                Tra cứu số CCCD ra SĐT<span
                  :class="rootClass + '__dropdown-content-icon'"
              ><feather-icon class="mr-50" icon="GridIcon" size="16"
              /></span>
              </div>
            </a>
            <a
                :class="rootClass + '__dropdown-content-item'"
                href="#"
                @click="openTab('DkttHistory', 'Tra cứu lịch sử DKTT')"
            >
              <div :class="rootClass + '__dropdown-content-item-left'"></div>
              <div :class="rootClass + '__dropdown-content-item-right'">
                Tra cứu lịch sử DKTT<span
                  :class="rootClass + '__dropdown-content-icon'"
              ><feather-icon class="mr-50" icon="GridIcon" size="16"
              /></span>
              </div>
            </a>
            <a
                :class="rootClass + '__dropdown-content-item'"
                href="#"
                @click="openTab('subMGM', 'Tra cứu mã MGM')"
            >
              <div :class="rootClass + '__dropdown-content-item-left'"></div>
              <div :class="rootClass + '__dropdown-content-item-right'">
                Tra cứu mã MGM<span
                  :class="rootClass + '__dropdown-content-icon'"
              ><feather-icon class="mr-50" icon="GridIcon" size="16"
              /></span>
              </div>
            </a>
<!--            <a-->
<!--                :class="rootClass + '__dropdown-content-item'"-->
<!--                href="#"-->
<!--                @click="openTab('memberPack', 'Tra cứu COMBO hội viên')"-->
<!--            >-->
<!--              <div :class="rootClass + '__dropdown-content-item-left'"></div>-->
<!--              <div :class="rootClass + '__dropdown-content-item-right'">-->
<!--                COMBO hội viên<span-->
<!--                  :class="rootClass + '__dropdown-content-icon'"-->
<!--              ><feather-icon class="mr-50" icon="GridIcon" size="16"-->
<!--              /></span>-->
<!--              </div>-->
<!--            </a>-->
            <a
                :class="rootClass + '__dropdown-content-item'"
                href="#"
                @click="openTab('PackageHistory', 'Tra cứu lịch sử 3G')"
            >
              <div :class="rootClass + '__dropdown-content-item-left'"></div>
              <div :class="rootClass + '__dropdown-content-item-right'">
                Tra cứu lịch sử 3G<span
                  :class="rootClass + '__dropdown-content-icon'"
              ><feather-icon class="mr-50" icon="GridIcon" size="16"
              /></span>
              </div>
            </a>
            <a
                :class="rootClass + '__dropdown-content-item'"
                href="#"
                @click="openTab('CdrByMonth', 'Lịch sử cuộc gọi, nhắn tin')"
            >
              <div :class="rootClass + '__dropdown-content-item-left'"></div>
              <div :class="rootClass + '__dropdown-content-item-right'">
                Lịch sử cuộc gọi, nhắn tin<span
                  :class="rootClass + '__dropdown-content-icon'"
              ><feather-icon class="mr-50" icon="GridIcon" size="16"
              /></span>
              </div>
            </a>
            <a
                :class="rootClass + '__dropdown-content-item'"
                href="#"
                @click="openTab('PackageDetail', 'Gói cước chi tiết')"
            >
              <div :class="rootClass + '__dropdown-content-item-left'"></div>
              <div :class="rootClass + '__dropdown-content-item-right'">
                Gói cước chi tiết<span
                  :class="rootClass + '__dropdown-content-icon'"
              ><feather-icon class="mr-50" icon="GridIcon" size="16"
              /></span>
              </div>
            </a>
            <a
                :class="rootClass + '__dropdown-content-item'"
                href="#"
                @click="openTab('RechargeHistory', 'Lịch sử nạp thẻ')"
            >
              <div :class="rootClass + '__dropdown-content-item-left'"></div>
              <div :class="rootClass + '__dropdown-content-item-right'">
                Lịch sử nạp thẻ<span
                  :class="rootClass + '__dropdown-content-icon'"
              ><feather-icon class="mr-50" icon="GridIcon" size="16"
              /></span>
              </div>
            </a>
            <a
                :class="rootClass + '__dropdown-content-item'"
                href="#"
                @click="openTab('CountCallsByDateRange', 'Tra cứu cắt khẩn cấp')"
            >
              <div :class="rootClass + '__dropdown-content-item-left'"></div>
              <div :class="rootClass + '__dropdown-content-item-right'">
                Tra cứu cắt khẩn cấp<span
                  :class="rootClass + '__dropdown-content-icon'"
              ><feather-icon class="mr-50" icon="GridIcon" size="16"
              /></span>
              </div>
            </a>
            <a
                :class="rootClass + '__dropdown-content-item'"
                href="#"
                @click="openTab('SmoSmtHistory', 'Tra cứu lịch sử SMO/SMT')"
            >
              <div :class="rootClass + '__dropdown-content-item-left'"></div>
              <div :class="rootClass + '__dropdown-content-item-right'">
                Tra cứu lịch sử SMO/SMT<span
                  :class="rootClass + '__dropdown-content-icon'"
              ><feather-icon class="mr-50" icon="GridIcon" size="16"
              /></span>
              </div>
            </a>
          </div>
        </a>
        <!--        <a href="#" :class="rootClass + '__dropdown-content-item'">-->
        <!--          <div :class="rootClass + '__dropdown-content-item-left'"></div>-->
        <!--          <div :class="rootClass + '__dropdown-content-item-right'">-->
        <!--            CCBS<span :class="rootClass + '__dropdown-content-icon'"-->
        <!--          ><feather-icon size="16" icon="GridIcon" class="mr-50"-->
        <!--          /></span>-->
        <!--          </div>-->
        <!--        </a>-->
        <!--        <a href="#" :class="rootClass + '__dropdown-content-item'">-->
        <!--          <div :class="rootClass + '__dropdown-content-item-left'"></div>-->
        <!--          <div :class="rootClass + '__dropdown-content-item-right'">-->
        <!--            TTTC<span :class="rootClass + '__dropdown-content-icon'"-->
        <!--          ><feather-icon size="16" icon="GridIcon" class="mr-50"-->
        <!--          /></span>-->
        <!--          </div>-->
        <!--        </a>-->
        <!--        <a href="#" :class="rootClass + '__dropdown-content-item'">-->
        <!--          <div :class="rootClass + '__dropdown-content-item-left'"></div>-->
        <!--          <div :class="rootClass + '__dropdown-content-item-right'">-->
        <!--            CCOS<span :class="rootClass + '__dropdown-content-icon'"-->
        <!--          ><feather-icon size="16" icon="GridIcon" class="mr-50"-->
        <!--          /></span>-->
        <!--          </div>-->
        <!--        </a>-->
      </div>
    </div>
  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BButtonGroup,
  BCard,
  BCol,
  BContainer,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BImg,
  BInputGroup,
  BInputGroupPrepend,
  BLink,
  BMedia,
  BModal,
  BPagination,
  BRow,
  BTab,
  BTable,
  BTabs,
  BTooltip
} from "bootstrap-vue";

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BModal,
    BFormGroup,
    BFormCheckbox,
    BImg,
    BButtonGroup,
    BInputGroup,
    BInputGroupPrepend,
    BTabs,
    BTab,
    BContainer,
    BFormDatepicker
  },
  data() {
    return {
      rootClass: "search-drop-menu",
      count: 0
    };
  },
  methods: {
    openTab(value, text) {
      event.stopImmediatePropagation();
      let tab = {value: value, text: text};
      this.$emit("openTab", tab);
    }
  }
};
</script>

<style lang="scss" scoped>
.search-drop-menu {
  &__menu-right-dropdown {
    position: relative;
    display: inline-block;
  }

  &__menu-right-dropdown:hover &__dropdown-content {
    display: block;
    border: 1px solid #707070;
  }

  &__dropdown-content-sub {
    border: 1px solid #707070;
  }

  &__menu-btn {
    position: relative;
    background: transparent !important;
    color: #8d8d8d !important;
    border: unset;
  }

  &__dropdown-content {
    border: 1px solid #707070;
    display: none;
    position: absolute;
    border-radius: 6px;
    background: white;
    text-align: end;
    top: 0;
    left: 0;
    min-width: 270px;
    z-index: 1;
    transform: translate(-100%, 0%);

    &-sub {
      display: none;
      position: absolute;
      border-radius: 6px;
      background: white;
      text-align: end;
      top: 0;
      left: 0;
      min-width: 270px;
      z-index: 1;
      transform: translate(-100%, 0%);
    }

    &-item {
      color: black;
      padding: 12px 2px;
      text-decoration: none;
      display: flex;

      //&-left {
      //  width: 10%;
      //}

      &-right {
        width: 100%;
      }
    }

    &-item:hover {
      color: white;
      //background-color: #f13e27;
      background: rgb(251, 94, 72);
      background: linear-gradient(
              0deg,
              rgba(251, 94, 72, 1) 0%,
              rgba(249, 121, 106, 1) 67%
      );
    }

    &-item:hover &-sub {
      display: block;
    }

    &-icon {
      margin-left: 1rem;
    }
  }
}
</style>
